/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useState } from "react";
import { useSelector } from "react-redux";
import { TransactionAllocation, BudgetItem, BudgetType, CurrentUser, DateTime, FamilyHasAccess, TimeframeItem, TransactionItem, USCurrency } from "../types";
import { useItems } from "../features/Fetch/Items";
import { Button, Grid, IconButton } from "@mui/material";
import { BoxArrowUpRight, PencilFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { Features } from "../constants";
import Date from "../components/Inputs/Date";

const Budgets = (props: any) => {
	const repo = useItems();
	const user: CurrentUser = useSelector((state: any) => state.userData.value);

	const navigate = useNavigate();

	const [currentDate, setCurrentDate] = useState(new DateTime());

	const transactions: TransactionItem[] = useSelector((state: any) => state.transactions.value);
	const timeframes: TimeframeItem[] = useSelector((state: any) => state.timeframes.value);
	const budgets: BudgetItem[] = useSelector((state: any) => state.budgets.value);

	const canLoad = transactions && timeframes && budgets && user;
	const earliest = new DateTime([...budgets.filter(b => b.budgetType !== BudgetType.Income && b.variant.amount > 0)].map(b => b.variant.startDate.Value).reduce((minDate, currentDate) => currentDate < minDate ? currentDate : minDate, new DateTime().Value));
	const sumUnbudgeted = ([] as TransactionAllocation[]).concat.apply([], transactions?.filter(t => t.transactionDate.startOfDay().Value >= earliest.Value).map(t => t.allocations?.filter(a => a.budgetId < 1))).reduce((total, t) => total + t.amount, 0);
	const sumLimited = budgets.filter(b => b.budgetType !== BudgetType.Income && b.variant.amount > 0).reduce((total, t) => total + t.amountSpent, 0);
	const limitLimited = budgets.filter(b => b.budgetType !== BudgetType.Income && b.variant.amount > 0).reduce((total, t) => total + t.variant.amount, 0);
	const overLimit = sumLimited > limitLimited;
	const overLimitItems = budgets.filter(b => b.budgetType !== BudgetType.Income && b.variant.amount > 0 && b.amountRemaining < 0);

	if (!FamilyHasAccess(user, Features.Budgets)) {
		navigate("/");
		return <></>;
	}
	if (!FamilyHasAccess(user, Features.Taxes)) {
		navigate("/budgets/all");
		return <></>;
	}

	return (
		<>
			<Grid container rowSpacing={3} justifyContent="center">
				<Grid item xs={8}>
					<h2 className="mt-2 text-app">Budgets</h2>
				</Grid>
				<Grid item xs={3}>
					{!canLoad && (< p ><em>Loading...</em></p>)}
					{canLoad && user.isHoH && (
						<>
							Add/Edit
							<IconButton
								className="text-app right"
								aria-label='Edit Budgets'
								onClick={() => navigate('/bulkbudgets')}>
								<PencilFill />
							</IconButton>
						</>
					)}
				</Grid>
				{canLoad && (<>
					<Grid container className="border border-app my-3 mx-3 budget-summary-container bg-white" style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: -1, paddingRight: -1 }}>
						<Grid item xs={2} className='centered text-app'>
						</Grid>
						<Grid item xs={8} className='my-3'>
							<Grid item xs={12} className='centered text-app'>
								<b>Limited Budgets</b>
							</Grid>
							<Grid item xs={12} className={`centered pb-2 ${overLimit ? 'text-danger' : 'text-app'}`} onClick={() => navigate('/budgets/limited')}>
								{USCurrency(sumLimited)} of {USCurrency(limitLimited)} spent
								<div className='centered mt-2'>
									{overLimit ? <>
										{USCurrency(sumLimited - limitLimited)} over
									</> : <>
										{USCurrency(limitLimited - sumLimited)} remaining
									</>}
								</div>
								<div className='centered text-danger small mt-2'>
									{overLimitItems.map(i => `${i.description}: ${USCurrency(i.amountRemaining)} | `)}
								</div>
								{sumUnbudgeted > 0 &&
									<div className='centered text-secondary small mt-2'>
										Unbudgeted since {earliest.toString()} - {USCurrency(sumUnbudgeted)}
									</div>
								}
							</Grid>
							{user.isHoH &&
								<Grid item xs={12} className={`centered pb-2`}>
									<Button fullWidth variant="contained" onClick={() => navigate("/balancebudgets")} className="bg-success text-white">Balance Budgets</Button>
								</Grid>
							}
						</Grid>
						<Grid item xs={2} className='centered text-app cursor-pointer align-self-center' onClick={() => navigate('/budgets/limited')}>
							<div className='h-100 w-100 centered align-content-center'>
								<h3><BoxArrowUpRight /></h3>
							</div>
						</Grid>
					</Grid>
					<Grid container className="border border-app my-1 mx-3 budget-summary-container bg-white cursor-pointer" style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: -1, paddingRight: -1 }} onClick={() => navigate('/budgets/all')}>
						<Grid item xs={12} className='centered py-3 text-app'>
							<h3 className='mb-0 align-content-center'>View All Budgets<BoxArrowUpRight style={{ marginLeft: '1rem' }} /></h3>
						</Grid>
					</Grid>
					<Grid item xs={3} className="centered align-self-center">
					</Grid>
					<Grid item xs={6} className="centered">
						<Date Borderless Size={12} Label="As of..." Value={currentDate} OnChange={UpdateDate} />
					</Grid>
					<Grid item xs={3} className="centered align-self-center">
					</Grid>
				</>)}
			</Grid>
		</>
	);

	function UpdateDate(newValue: any) {
		newValue = new DateTime(newValue);
		repo.GetBudgetsWithDateAsync(newValue);
		setCurrentDate(newValue);
	}
}

export default Budgets;